import {
  OlympicDto,
  OlympicParticipantDto,
  QuestionDto,
  State,
} from "../../interfaces";
import { Paginated } from "../../models";
import {
  ADD_OLYMPIC_QUESTION,
  ADD_OLYMPIC_QUESTION_ERROR,
  ADD_OLYMPIC_QUESTION_SUCCESS,
  ActionTypes,
  DELETE_OLYMPIC_QUESTION,
  DELETE_OLYMPIC_QUESTION_CONSENT,
  DELETE_OLYMPIC_QUESTION_ERROR,
  DELETE_OLYMPIC_QUESTION_SUCCESS,
  GET_OLYMPIC_QUESTION,
  GET_QUESTIONS_BY_OLYMPIC,
  GET_QUESTIONS_BY_OLYMPIC_ERROR,
  GET_QUESTIONS_BY_OLYMPIC_SUCCESS,
  GET_OLYMPIC_QUESTION_ERROR,
  GET_OLYMPIC_QUESTION_SUCCESS,
  TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL,
  UPDATE_OLYMPIC_QUESTION,
  UPDATE_OLYMPIC_QUESTION_ERROR,
  UPDATE_OLYMPIC_QUESTION_SUCCESS,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR,
  UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS,
  ADD_UPDATE_OLYMPIC,
  ADD_UPDATE_OLYMPIC_SUCCESS,
  ADD_UPDATE_OLYMPIC_ERROR,
  GET_OLYMPIC,
  GET_OLYMPIC_ERROR,
  GET_OLYMPIC_SUCCESS,
  GET_OLYMPICS_SUCCESS,
  GET_OLYMPICS,
  GET_OLYMPICS_ERROR,
  DELETE_OLYMPIC,
  DELETE_OLYMPIC_CONSENT,
  DELETE_OLYMPIC_ERROR,
  DELETE_OLYMPIC_SUCCESS,
  GET_OLYMPIC_PARTICIPANTS,
  GET_OLYMPIC_PARTICIPANTS_ERROR,
  GET_OLYMPIC_PARTICIPANTS_SUCCESS,
} from "./actionTypes";

export class OlympicState {
  questionsByOlympic: State<Paginated<QuestionDto>>;
  olympicQuestion: State<QuestionDto>;
  addOlympicQuestion: State<any>;
  updateOlympicQuestion: State<any>;
  deleteOlympicQuestion: State<any>;
  olympicQuestionDisplayImage: State<File>;
  addUpdateOlympic: State<any>;
  olympic: State<OlympicDto>;
  olympics: State<Paginated<OlympicDto>>;
  deleteOlympic: State<any>;
  olympicParticipants: State<Paginated<OlympicParticipantDto>>;
  constructor() {
    this.questionsByOlympic = {
      loading: false,
      error: null,
      success: false,
    };
    this.olympicQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.addOlympicQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateOlympicQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteOlympicQuestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.questionsByOlympic = {
      loading: false,
      error: null,
      success: false,
    };
    this.olympicQuestionDisplayImage = {
      loading: false,
      error: null,
      success: false,
    };
    this.addUpdateOlympic = {
      loading: false,
      error: null,
      success: false,
    };
    this.olympic = {
      loading: false,
      error: null,
      success: false,
    };
    this.olympics = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteOlympic = {
      loading: false,
      error: null,
      success: false,
    };
    this.olympicParticipants = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: OlympicState = new OlympicState();

export const olympic = (
  state: OlympicState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_QUESTIONS_BY_OLYMPIC:
      state = {
        ...state,
        questionsByOlympic: {
          ...state.questionsByOlympic,
          loading: true,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_QUESTIONS_BY_OLYMPIC_SUCCESS:
      state = {
        ...state,
        questionsByOlympic: {
          ...state.questionsByOlympic,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_QUESTIONS_BY_OLYMPIC_ERROR:
      state = {
        ...state,
        questionsByOlympic: {
          ...state.questionsByOlympic,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_OLYMPIC_QUESTION:
      state = {
        ...state,
        olympicQuestion: {
          ...state.olympicQuestion,
          loading: true,
          success: false,
          error: null,
        },
        addOlympicQuestion: {
          ...state.addOlympicQuestion,
          loading: false,
          success: false,
          error: null,
        },
        updateOlympicQuestion: {
          ...state.updateOlympicQuestion,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_OLYMPIC_QUESTION_SUCCESS:
      state = {
        ...state,
        olympicQuestion: {
          ...state.olympicQuestion,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_OLYMPIC_QUESTION_ERROR:
      state = {
        ...state,
        olympicQuestion: {
          ...state.olympicQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_OLYMPIC_QUESTION:
      state = {
        ...state,
        addOlympicQuestion: {
          ...state.addOlympicQuestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_OLYMPIC_QUESTION_SUCCESS:
      state = {
        ...state,
        addOlympicQuestion: {
          ...state.addOlympicQuestion,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_OLYMPIC_QUESTION_ERROR:
      state = {
        ...state,
        addOlympicQuestion: {
          ...state.addOlympicQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPDATE_OLYMPIC_QUESTION:
      state = {
        ...state,
        updateOlympicQuestion: {
          ...state.updateOlympicQuestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_OLYMPIC_QUESTION_SUCCESS:
      state = {
        ...state,
        updateOlympicQuestion: {
          ...state.updateOlympicQuestion,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case UPDATE_OLYMPIC_QUESTION_ERROR:
      state = {
        ...state,
        updateOlympicQuestion: {
          ...state.updateOlympicQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_OLYMPIC_QUESTION_CONSENT:
      state = {
        ...state,
        deleteOlympicQuestion: {
          ...state.deleteOlympicQuestion,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_OLYMPIC_QUESTION:
      state = {
        ...state,
        deleteOlympicQuestion: {
          ...state.deleteOlympicQuestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_OLYMPIC_QUESTION_SUCCESS:
      state = {
        ...state,
        deleteOlympicQuestion: {
          ...state.deleteOlympicQuestion,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_OLYMPIC_QUESTION_ERROR:
      state = {
        ...state,
        deleteOlympicQuestion: {
          ...state.deleteOlympicQuestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE:
      state = {
        ...state,
        olympicQuestionDisplayImage: {
          ...state.olympicQuestionDisplayImage,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_SUCCESS:
      state = {
        ...state,
        olympicQuestionDisplayImage: {
          ...state.olympicQuestionDisplayImage,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case UPLOAD_OLYMPIC_QUESTION_DISPLAY_IMAGE_ERROR:
      state = {
        ...state,
        olympicQuestionDisplayImage: {
          ...state.olympicQuestionDisplayImage,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_ADD_EDIT_OLYMPIC_QUESTION_MODAL:
      state = {
        ...state,
        olympicQuestion: {
          ...state.olympicQuestion,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
        olympicQuestionDisplayImage: {
          ...state.olympicQuestionDisplayImage,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case ADD_UPDATE_OLYMPIC:
      state = {
        ...state,
        addUpdateOlympic: {
          ...state.addUpdateOlympic,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_UPDATE_OLYMPIC_SUCCESS:
      state = {
        ...state,
        addUpdateOlympic: {
          ...state.addUpdateOlympic,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_UPDATE_OLYMPIC_ERROR:
      state = {
        ...state,
        addUpdateOlympic: {
          ...state.addUpdateOlympic,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_OLYMPIC:
      state = {
        ...state,
        olympic: {
          ...state.olympic,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_OLYMPIC_SUCCESS:
      state = {
        ...state,
        olympic: {
          ...state.olympic,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_OLYMPIC_ERROR:
      state = {
        ...state,
        olympic: {
          ...state.olympic,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_OLYMPICS:
      state = {
        ...state,
        olympics: {
          ...state.olympics,
          loading: true,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_OLYMPICS_SUCCESS:
      state = {
        ...state,
        olympics: {
          ...state.olympics,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_OLYMPICS_ERROR:
      state = {
        ...state,
        olympics: {
          ...state.olympics,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_OLYMPIC_CONSENT:
      state = {
        ...state,
        deleteOlympic: {
          ...state.deleteOlympic,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_OLYMPIC:
      state = {
        ...state,
        deleteOlympic: {
          ...state.deleteOlympic,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_OLYMPIC_SUCCESS:
      state = {
        ...state,
        deleteOlympic: {
          ...state.deleteOlympic,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_OLYMPIC_ERROR:
      state = {
        ...state,
        deleteOlympic: {
          ...state.deleteOlympic,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_OLYMPIC_PARTICIPANTS:
      state = {
        ...state,
        olympicParticipants: {
          ...state.olympicParticipants,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_OLYMPIC_PARTICIPANTS_SUCCESS:
      state = {
        ...state,
        olympicParticipants: {
          ...state.olympicParticipants,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_OLYMPIC_PARTICIPANTS_ERROR:
      state = {
        ...state,
        olympicParticipants: {
          ...state.olympicParticipants,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
